import {
  getAgreements,
  getAuthLink,
  getCountries,
  getPurposes,
  GetMonthlyTurnovers,
  getCities,
  getFullCountries,
  submitForm,
  sendSmsTanCode,
  getStartupCapitalSources,
  getCompanyIncomeSources,
  getBanks,
  GetPropertieSources,
  getMoneySecondSources,
  getPepCategory,
  sendFiles,
} from "./common/sharedServices";
import {
  localToken,
  // getCookieValue,
  getInstance,
  apiCallWithAntiForgery,
  setAntiforgery,
} from "./common";

// const requestToken = getCookieValue("XSRF-REQUEST-TOKEN");
async function GetLegalCountries() {
  return getInstance(localToken()).get("Reference/GetCountriesForLegal");
}
async function GetLegalForms() {
  return getInstance(localToken()).get("Reference/GetLegalForm");
}
async function getEconomicActivityTypes() {
  return getInstance(localToken()).get("Reference/GetEconomicActivityTypes");
}
async function getTaxClassifications() {
  return getInstance(localToken()).get("/reference/GetTaxClassifications");
}
const Services = {
  getAuthLink,
  getAgreements,
  GetLegalCountries,
  apiCallWithAntiForgery,
  setAntiforgery,
  getCountries,
  getPurposes,
  GetMonthlyTurnovers,
  getCities,
  getFullCountries,
  GetLegalForms,
  submitForm,
  sendSmsTanCode,
  getEconomicActivityTypes,
  getStartupCapitalSources,
  getCompanyIncomeSources,
  getBanks,
  GetPropertieSources,
  getMoneySecondSources,
  getPepCategory,
  getTaxClassifications,
  sendFiles,
};

export default Services;
